/**
 * @param {string} str
 */
export default function upperFirst(str) {
    if (typeof str !== "string") {
        str = String(str);
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
}



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/lib/utils/upperFirst.js
// module id = 18
// module chunks = 2